import React from "react";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import { ListItem, ListItemSecondaryAction, ListItemText, List as MuiList } from "@material-ui/core";

import { translate } from "jazasoft";

import ResourceKeys from "../../../utils/ResourceKeys";
import { useSetting } from "../../../hooks";
import SettingKeys from "../../../utils/SettingKeys";
import { getDistinctValues, isEmpty } from "../../../utils/helpers";

const getUpdateText = (field, fromValue, toValue) => {
  return (
    <div>
      <span style={{ fontWeight: "bold" }}>{field}</span> changed from '
      <span style={{ fontStyle: "italic", textDecoration: "underline" }}>{fromValue}</span> ' to '
      <span style={{ fontStyle: "italic", textDecoration: "underline" }}>{toValue}</span> '
    </div>
  );
};

const LibraryDetails = ({ userActivity, translate }) => {
  const resource = ResourceKeys[userActivity?.entityName];
  const entityFieldList = useSetting(SettingKeys.ENTITY_FIELDS, resource);
  const entityFields = getDistinctValues(["id", "unitIds", ...entityFieldList]);

  const prevValue = JSON.parse(userActivity?.prevValue || "{}");
  const currValue = JSON.parse(userActivity?.currValue || "{}");

  return (
    <PerfectScrollbar>
      {(userActivity?.method === "POST" || userActivity?.method === "DELETE") && (
        <MuiList disablePadding>
          {entityFields
            ?.filter(field =>
              userActivity?.method === "POST"
                ? Object.keys(currValue).includes(field) && !isEmpty(currValue[field])
                : Object.keys(prevValue).includes(field) && !isEmpty(prevValue[field])
            )
            ?.map((field, idx) => {
              const translatedText = `${translate(`resources.${resource}.fields.${field}`, { _: field })}`;
              return (
                <ListItem key={idx} divider>
                  <ListItemText primary={translatedText} />
                  <ListItemSecondaryAction>
                    <ListItemText primary={userActivity?.method === "POST" ? currValue[field] : prevValue[field]} />
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
        </MuiList>
      )}
      {userActivity?.method === "PUT" && (
        <MuiList disablePadding>
          {entityFields
            ?.filter(field => Object.keys(currValue).includes(field) && !isEmpty(currValue[field]) && currValue[field] !== prevValue[field])
            ?.map((field, idx) => {
              const translatedText = `${translate(`resources.${resource}.fields.${field}`, { _: field })}`;
              const styledText = getUpdateText(translatedText, prevValue[field], currValue[field]);
              return (
                <ListItem key={idx} divider>
                  <ListItemText primary={styledText} />
                </ListItem>
              );
            })}
        </MuiList>
      )}
    </PerfectScrollbar>
  );
};

export default translate(LibraryDetails);
